var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPawnBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_227_2297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.887 124.706C131.306 124.706 131.731 124.635 132.148 124.484C134.065 123.788 135.057 121.668 134.361 119.752C128.18 102.727 109.28 101.093 108.477 101.032C106.451 100.882 104.668 102.401 104.512 104.435C104.356 106.467 105.875 108.238 107.904 108.397C108.537 108.449 122.886 109.79 127.415 122.271C127.961 123.774 129.379 124.706 130.887 124.706Z",
    fill: "#28174C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6935 110.591C64.5977 110.591 68.8806 107.643 69.1905 107.424C70.8521 106.242 71.2414 103.936 70.0597 102.272C68.8834 100.618 66.5993 100.226 64.9405 101.381C64.4826 101.688 55.3601 107.501 41.6834 96.4917C40.0931 95.2112 37.7706 95.4634 36.4901 97.0538C35.2097 98.6413 35.4619 100.969 37.0522 102.247C45.1272 108.745 52.2316 110.591 57.6935 110.591Z",
    fill: "#28174C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9152 143.028C56.6598 138.117 64.7019 138.103 64.7019 138.103V126.705H80.1884L73.1635 143.028H53.9152Z",
    fill: "#412463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.731 143.028C121.986 138.117 113.944 138.103 113.944 138.103V126.705H98.4579L105.483 143.028H124.731Z",
    fill: "#412463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7186 99.0225V126.705H121.756L112.288 99.0225H88.7186Z",
    fill: "#28174C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7185 99.0225V126.705H55.681L65.1489 99.0225H88.7185Z",
    fill: "#28174C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7185 112.864C68.8293 112.864 52.7059 96.7405 52.7059 76.8513C52.7059 56.9621 68.8293 40.8387 88.7185 40.8387C108.608 40.8387 124.731 56.9621 124.731 76.8513C124.731 96.7405 108.608 112.864 88.7185 112.864Z",
    fill: "#412463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5539 96.2723H88.7185H112.88L116.365 106.456C109.823 114.468 99.87 119.584 88.7185 119.584C77.5671 119.584 67.6139 114.468 61.0716 106.456L64.5539 96.2723Z",
    fill: "#412463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7186 109.017C72.3138 109.017 59.0152 95.7182 59.0152 79.3135C59.0152 62.9087 72.3138 49.61 88.7186 49.61C105.123 49.61 118.422 62.9087 118.422 79.3135C118.422 95.7182 105.123 109.017 88.7186 109.017Z",
    fill: "#C17468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0292 89.22C68.4302 89.22 64.7019 85.4918 64.7019 80.8928C64.7019 76.2938 68.4302 72.5656 73.0292 72.5656C77.6282 72.5656 81.3564 76.2938 81.3564 80.8928C81.3564 85.4918 77.6282 89.22 73.0292 89.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2587 72.6039C74.3234 74.1202 75.6696 76.5578 75.6696 79.3134C75.6696 83.6512 72.3492 87.2129 68.1129 87.6023C66.0482 86.086 64.7019 83.6484 64.7019 80.8928C64.7019 76.5523 68.0224 72.9932 72.2587 72.6039Z",
    fill: "#341F5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.059 89.22C101.459 89.22 97.7313 85.4918 97.7313 80.8928C97.7313 76.2938 101.459 72.5656 106.059 72.5656C110.658 72.5656 114.386 76.2938 114.386 80.8928C114.386 85.4918 110.658 89.22 106.059 89.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.288 72.6039C107.353 74.1202 108.699 76.5578 108.699 79.3134C108.699 83.6512 105.378 87.2129 101.142 87.6023C99.0775 86.086 97.7312 83.6484 97.7312 80.8928C97.7312 76.5523 101.049 72.9932 105.288 72.6039Z",
    fill: "#341F5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8324 41.1182C74.8882 36.0128 86.0451 39.1934 91.9869 37.5373C96.1053 36.3884 96.2808 32.1823 98.3016 32.6319C100.322 33.0816 98.6937 36.967 101.935 39.7555C106.607 43.7779 118.057 45.6424 123.182 53.6873C125.927 57.9976 124.388 64.4878 123.747 66.8102L92.2446 59.7826L60.7425 52.755C61.1511 50.3805 62.5166 43.852 66.8324 41.1182Z",
    fill: "#28174C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1697 50.3997L135.97 69.5384C138.457 70.0923 140.311 72.7081 139.732 75.2965L42.6677 53.6434C43.2463 51.055 47.0631 49.706 50.1697 50.3997Z",
    fill: "#412463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7185 90.4511C89.3985 90.4511 89.9497 89.9 89.9497 89.22C89.9497 88.54 89.3985 87.9889 88.7185 87.9889C86.9911 87.9889 85.5845 86.5823 85.5845 84.8548C85.5845 83.1274 86.9911 81.7208 88.7185 81.7208C89.3985 81.7208 89.9497 81.1697 89.9497 80.4897C89.9497 79.8097 89.3985 79.2585 88.7185 79.2585C85.6339 79.2585 83.1223 81.7702 83.1223 84.8548C83.1223 87.9395 85.6339 90.4511 88.7185 90.4511Z",
    fill: "#B75E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7185 96.3902C92.4393 96.3902 95.9024 94.7067 98.2166 91.77C98.6388 91.2354 98.5456 90.4622 98.0109 90.0399C97.4763 89.6204 96.703 89.7109 96.2808 90.2455C94.4355 92.5844 91.6798 93.9252 88.7158 93.9252C85.7517 93.9252 82.9961 92.5844 81.1508 90.2455C80.7285 89.7136 79.9553 89.6204 79.4206 90.0399C78.8859 90.4594 78.7954 91.2354 79.215 91.77C81.5346 94.7094 84.9977 96.3902 88.7185 96.3902Z",
    fill: "#7C184B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5601 45.5438L25.7801 42.8622C25.0672 42.3632 24.6833 41.6119 24.7492 40.8387L26.929 20.137C27.0222 19.0403 28.8483 18.8346 29.2898 19.8683L37.4142 39.7693C37.7185 40.485 37.6033 41.2774 37.1016 41.9107L33.0654 45.3162L31.5601 45.5438Z",
    fill: "#412463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.764 109.601C130.44 112.156 132.803 115.466 134.358 119.752C135.054 121.668 134.065 123.788 132.145 124.484C131.729 124.635 131.304 124.706 130.884 124.706C129.373 124.706 127.956 123.774 127.413 122.271C126.286 119.168 124.553 116.755 122.576 114.879C123.865 113.508 126.105 111.156 127.764 109.601Z",
    fill: "#412463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0495 102.244C35.4619 100.964 35.2096 98.6387 36.4874 97.0511C37.7679 95.4608 40.0903 95.2112 41.6806 96.489C43.6274 98.0574 45.4782 99.272 47.2303 100.223L44.1538 106.971C41.889 105.773 39.5172 104.229 37.0495 102.244Z",
    fill: "#412463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0003 143.028L28.2232 31.0581C28.1272 30.3836 28.5961 29.7612 29.2706 29.668C29.6654 29.6104 30.0356 29.7694 30.2988 30.0354C30.4825 29.8517 30.7101 29.7064 30.9871 29.668C31.6533 29.572 32.284 30.0409 32.3772 30.7154L48.179 142.858C48.1872 142.918 48.1269 142.973 48.0693 143.031H44.0003V143.028Z",
    fill: "#412463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3897 101.021C44.3897 101.021 40.7347 104.454 39.0594 101.021C37.3429 97.5034 41.6834 96.4889 41.6834 96.4889L44.3897 101.021Z",
    fill: "#3F225F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_227_2297",
    x: 24.7419,
    y: 19.1939,
    width: 115.097,
    height: 129.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.48387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_227_2297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_227_2297",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawnBlack);
export default __webpack_public_path__ + "static/media/pawn-black.d42a9afe7565874890de0be9d59b9067.svg";
export { ForwardRef as ReactComponent };